import { render } from "./BlogDetailsLeftSidebarPage.vue?vue&type=template&id=562e8fa5"
import script from "./BlogDetailsLeftSidebarPage.vue?vue&type=script&lang=js"
export * from "./BlogDetailsLeftSidebarPage.vue?vue&type=script&lang=js"

import exportComponent from "/src/Ewallet.Web/Scripts/landing-page/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__